module.exports = __webpack_public_path__ + "img/45.7ee1533a.jpg";